import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EntraAccountIdService {
  private readonly STORAGE_KEY = 'EntraUserId';
  private _entraUserId = signal<string | null>(this.loadFromStorage());

  readonly entraUserId = this._entraUserId.asReadonly();

  setEntraUserId(id: string): void {
    // if stored id is the same as the value input do nothing
    if (this._entraUserId() !== id) {
      this._entraUserId.set(id);
      try {
        sessionStorage.setItem(this.STORAGE_KEY, id);
      } catch (error) {
        console.error('Failed to write EntraUserId to sessionStorage', error);
        // Signal still updated - in-memory state preserved
      }
    }
  }

  private loadFromStorage(): string | null {
    try {
      return sessionStorage.getItem(this.STORAGE_KEY);
    } catch (error) {
      console.error('Failed to read EntraUserId from sessionStorage', error);
      return null;
    }
  }
}
